import { CommerceApiContext, EmhEnvironment } from '../common/types';

export const CONTEXT_STORAGE_KEY = 'commerce-api-context';

export const getCommerceApiContext = (
  environment: EmhEnvironment,
  configuredContext: CommerceApiContext,
): CommerceApiContext => {
  const localStorageContext = localStorage.getItem(CONTEXT_STORAGE_KEY) as CommerceApiContext;

  if (environment === 'prod') {
    return configuredContext;
  }

  if (localStorageContext === CommerceApiContext.FOC) {
    return CommerceApiContext.FOC;
  }

  if (localStorageContext === CommerceApiContext.OCB) {
    return CommerceApiContext.OCB;
  }

  if (configuredContext) {
    return configuredContext;
  }

  return CommerceApiContext.OCB;
};
